
export default {
  message: () => 'Geef een geldig telefoonnummer in.',
  validate: (value) => {
    value = value.replace(/\/|\./g, '');
    if (!value) return true;
    const pattern = /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,5})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/;
    const phone = value.toString().replace(/\s/g, '');

    return pattern.test(phone);
  }
};
